import { ApiContext } from '../../types'
import { deserializeAudio } from '@/api_client/api/serializers/audio'
import { Audio } from '@/api_client/types/audios'
import { AuthHelper } from '@/api_client'

export default async function redeemCode(
  { client, config }: ApiContext,
  redeemCode,
): Promise<any> {
  try {
    const bearerToken = AuthHelper.getAccessToken()

    const result = await client.purchases.redeemCode(
      bearerToken.toString(),
      redeemCode,
    )

    if (result.isSuccess()) {
      return true
    } else {
      return false
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
